import { Box } from '@chakra-ui/react';
import { TopNavBar } from 'src/components/templates/TopNavBar';
import { SidebarContent } from './SidebarContent';

export const SideNavBar = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box minH="100vh" bg="bg.layout">
      <SidebarContent />
      <TopNavBar />
      <Box ml={{ base: 0, md: '340px' }}>{children}</Box>
    </Box>
  );
};
